import styled from "styled-components";
import {
	MOBILE_L_BP,
	FONT_WT_LIGHT,
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	FONT_WT_REGULAR,
} from "@website-builder/utilities-index";

export const LeadershipWrapper = styled.div`
	padding: 80px 130px 45px 130px;
	.leadershipHeading {
		font-size: 28px;
		font-weight: ${FONT_WT_MEDIUM};
		text-align: center;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		padding-bottom: 55px;
	}
	.leadersBlock {
		display: flex;
		flex-flow: wrap;
		justify-content: center;
	}
	.leaderDetail {
		width: 200px;
		margin-left: 30px;
		margin-right: 30px;
		padding-bottom: 55px;
		.leaderImage {
			text-align: center;
		}
		.leaderName {
			font-size: 18px;
			text-align: center;
			font-weight: ${FONT_WT_REGULAR};
			color: ${COLOR_TEXT_PRIMARY_B2C};
			padding-top: 18px;
			padding-bottom: 10px;
		}
		.leaderDesignation {
			font-size: 16px;
			font-weight: ${FONT_WT_LIGHT};
			text-align: center;
			color: ${COLOR_TEXT_PRIMARY_B2C};
			padding-left: 25px;
			padding-right: 25px;
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 50px 20px 45px 20px;
		.leaderDetail {
			margin-left: 20px;
			margin-right: 20px;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 40px 5px 10px 5px;
		.leaderDetail {
			width: 140px;
			margin-right: 15px;
			margin-left: 15px;
			.leaderImage {
				picture {
					img {
						width: 136px;
					}
				}
			}
			.leaderDesignation {
				padding: 0px;
			}
		}
	}
`;
